<template>
  <div>
    <div v-show="!isShowTree">
      <a-tooltip class="item" placement="top">
        <template slot="title">
          <span>显示监测站树</span>
        </template>
        <a-button
          @click="(isShowTree = true), $emit('showTree', true)"
          size="small"
          icon="double-right"
        ></a-button>
      </a-tooltip>
    </div>
    <transition name="slide-fade">
      <div v-show="isShowTree" style="width: 280px">
        <a-tooltip class="item" placement="top" style="float: left;">
          <template slot="title">
            <span>收起监测站树</span>
          </template>
          <a-button
            @click="(isShowTree = false), $emit('showTree', false)"
            style="width:50%;"
            >收起</a-button
          >
        </a-tooltip>
        <a-button
          style="width:50%;float: left;margin-left: 0"
          @click="cancleAll"
          >全部取消</a-button
        >
        <a-input-search
          style="margin-bottom: 8px"
          placeholder="输入关键字进行过滤"
          @change="onChangeSearch"
        />
        <!-- @check-change="handleCheckChange" -->
        <el-tree
          v-if="groupTreeData.length"
          ref="tree"
          :data="groupTreeData"
          :props="treeProps"
          node-key="id"
          show-checkbox
          default-expand-all
          :check-strictly="false"
          @check="handleCheckChange"
          :filter-node-method="filterNode"
        />
        <el-tree
          v-if="!userMenuPower.controls.isHideGfStation"
          ref="treeSn"
          :data="groupTreeSn"
          :props="treeSnProps"
          node-key="id"
          show-checkbox
          check-strictly
          @check-change="handleSnCheckChange"
          :filter-node-method="filterSnNode"
        >
          <template slot-scope="{ node }">
            <span>{{ formatterGfName(node) }}</span>
          </template>
        </el-tree>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      isShowTree: true,
      treeProps: {
        label: "name",
        children: "children"
      },
      treeSnProps: {
        label: "station",
        children: "children"
      },
      groupTreeData: []
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "groupTree",
      "groupTreeSn",
      "checkedHistoryStationIds",
      "checkedGfStationIds",
      "userMenuPower"
    ])
  },
  async mounted() {
    if (this.groupTree.length) {
      let groupTree = this.$_.cloneDeep(this.groupTree);
      this.groupTreeData = groupTree?.[0]?.children;
      // 只显示水质微站，过滤掉无人船/无人机设备
      for (let a of this.groupTreeData) {
        for (let b of a.children) {
          for (let c of b.children) {
            c.children = c.children.filter(x => x.dev_type == 1);
          }
          b.children = b.children.filter(x => x.children.length);
        }
        a.children = a.children.filter(x => x.children.length);
      }
    }
    await this.getGroupTreeSn();
    this.$refs.tree.setCheckedKeys(this.checkedHistoryStationIds);
    this.$refs.treeSn.setCheckedKeys(this.checkedGfStationIds);
  },
  methods: {
    ...mapActions(["getGroupTreeSn"]),
    formatterGfName(node) {
      const gf_list = this.groupTreeSn[0].children;
      let cur_info = gf_list.find(x => x.station == node.label);
      if (cur_info && cur_info.station_level) {
        return `${node.label} (${cur_info.station_level}控)`;
      }
      return node.label;
    },
    onChangeSearch(e) {
      let value = e.target.value;
      this.$refs.tree.filter(value);
      this.$refs.treeSn.filter(value);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    filterSnNode(value, data) {
      if (!value) return true;
      return data.station.indexOf(value) !== -1;
    },
    handleCheckChange(v) {
      this.$store.commit(
        "updateCheckedHistoryStationIds",
        this.$refs.tree.getCheckedKeys()
      );
      // if (this.$refs.tree.getCheckedKeys().length <= 10) {
      //   this.$store.commit(
      //   "updateCheckedHistoryStationIds",
      //   this.$refs.tree.getCheckedKeys()
      // );
      // } else {
      //   this.$refs.tree.setChecked(v.Id,false)
      //   this.$message.warning('最多选择10条')
      // }
    },
    handleSnCheckChange(v) {
      this.$store.commit(
        "updateCheckedGfStationIds",
        this.$refs.treeSn.getCheckedKeys()
      );
    },
    cancleAll() {
      this.$store.commit("updateCheckedHistoryStationIds", []);
      this.$refs.tree.setCheckedKeys([]);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
